"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CborConstants = exports.isUInt8MajorType = exports.UInt8MajorType = exports.isMajorTypeTag = exports.MajorType = void 0;
var MajorType;
(function (MajorType) {
    MajorType[MajorType["unsigned"] = 0] = "unsigned";
    MajorType[MajorType["negative"] = 1] = "negative";
    MajorType[MajorType["bytes"] = 2] = "bytes";
    MajorType[MajorType["text"] = 3] = "text";
    MajorType[MajorType["array"] = 4] = "array";
    MajorType[MajorType["map"] = 5] = "map";
    MajorType[MajorType["tag"] = 6] = "tag";
    MajorType[MajorType["float_or_simple"] = 7] = "float_or_simple"; // 111x_xxxx // 
})(MajorType = exports.MajorType || (exports.MajorType = {}));
;
Object.freeze(MajorType);
function isMajorTypeTag(majorTag) {
    return (majorTag >= 0 && majorTag <= 7 &&
        majorTag === Math.round(majorTag));
}
exports.isMajorTypeTag = isMajorTypeTag;
var UInt8MajorType;
(function (UInt8MajorType) {
    UInt8MajorType[UInt8MajorType["unsigned"] = 0] = "unsigned";
    UInt8MajorType[UInt8MajorType["negative"] = 32] = "negative";
    UInt8MajorType[UInt8MajorType["bytes"] = 64] = "bytes";
    UInt8MajorType[UInt8MajorType["text"] = 96] = "text";
    UInt8MajorType[UInt8MajorType["array"] = 128] = "array";
    UInt8MajorType[UInt8MajorType["map"] = 160] = "map";
    UInt8MajorType[UInt8MajorType["tag"] = 192] = "tag";
    UInt8MajorType[UInt8MajorType["float_or_simple"] = 224] = "float_or_simple";
})(UInt8MajorType = exports.UInt8MajorType || (exports.UInt8MajorType = {}));
Object.freeze(UInt8MajorType);
function isUInt8MajorType(byte) {
    return ((byte & 224) === byte &&
        isMajorTypeTag(byte >> 5));
}
exports.isUInt8MajorType = isUInt8MajorType;
/**
 * @static
 */
var AddInfos = /** @class */ (function () {
    function AddInfos() {
    }
    AddInfos.Length = Object.freeze({
        expect_uint8: 24,
        expect_uint16: 25,
        expect_uint32: 26,
        expect_uint64: 27,
        make_infinite: 31
    });
    AddInfos.Tag = {
        utf8_string: 0 | 0,
        epoch_datetime: 1 | 0,
        positive_bignum: 2 | 0,
        negative_bignum: 3 | 0,
        decimal_frac_array: 4 | 0,
        bigfloat: 5 | 0,
        expect_base64_url: 21 | 0,
        expect_base64: 22 | 0,
        expect_base16: 23 | 0,
        sub_cbor: 24 | 0,
        uri: 32 | 0,
        base64_url: 33 | 0,
        base64: 34 | 0,
        regexp: 35 | 0,
        MIME: 36 | 0,
        self_cbor: 55799 | 0
    };
    AddInfos.Major7 = Object.freeze({
        false: 20,
        true: 21,
        null: 22,
        undefined: 23,
        simple_byte: 24,
        float_half: 25,
        float_single: 26,
        float_double: 27,
        infinite_break: 31
    });
    return AddInfos;
}());
/**
 * @static
 */
var CborConstants = /** @class */ (function () {
    function CborConstants() {
    }
    ;
    CborConstants.MajorTypeMask = 224;
    CborConstants.AdditionalInfosMask = 31;
    CborConstants.AddInfos = AddInfos;
    CborConstants.MajorType = Object.freeze({
        unsigned: 0,
        negative: 1,
        bytes: 2,
        text: 3,
        array: 4,
        map: 5,
        tag: 6,
        float_or_simple: 7 // 111x_xxxx // 
    });
    CborConstants.UInt8MajorType = Object.freeze({
        unsigned: 0,
        negative: 32,
        bytes: 64,
        text: 96,
        array: 128,
        map: 160,
        tag: 192,
        float_or_simple: 224
    });
    CborConstants.infinite_break = 255; // 0xff // 255
    return CborConstants;
}());
exports.CborConstants = CborConstants;
